import { render, staticRenderFns } from "./RenWei.vue?vue&type=template&id=43c80ab6&scoped=true&"
import script from "./RenWei.vue?vue&type=script&lang=js&"
export * from "./RenWei.vue?vue&type=script&lang=js&"
import style0 from "./RenWei.vue?vue&type=style&index=0&id=43c80ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c80ab6",
  null
  
)

export default component.exports